import { styled } from "@mui/system";
import { Link } from "react-router-dom";

export default function NavigationLink({
  children,
  to,
  theme,
  selected,
  ...props
}) {
  const StyledLink = styled(Link)(({ selected, theme }) => ({
    fontSize: "18px",
    fontWeight: "400",
    transition: "box-shadow 0.3s ease",
    textDecoration: selected ? "underline" : "none",
    textUnderlineOffset: "8px",
    position: "relative",
    borderRadius: "0px",
    textDecorationColor: theme.palette.primary.main,
    textDecorationThickness: "2px",
  }));

  return (
    <StyledLink to={to} theme={theme} selected={selected}>
      {children}
    </StyledLink>
  );
}
